import { RoleRouteObject, RouteFunctionParams } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { faPencil } from '@fortawesome/free-solid-svg-icons'
import CustomizationsPage from '@/routes/customizations/CustomizationsPage'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { defer, LoaderFunction } from 'react-router-typesafe'
import { getAzureUserInformation } from '@/auth/azure/azureManager'
import CustomizationCreatorRoute from '@/routes/customizations/CustomizationCreator.route'
import CustomizationEditorRoute from '@/routes/customizations/CustomizationEditor.route'

export const customizationsPageRouteLoader = (async ({ request, params }: RouteFunctionParams) => {
  const qsAdminApi = useQsAdminApiManager.getState().service

  const getAziende = qsAdminApi.azienda().query((builder, azienda) => {
    builder.select('id', 'nome')
    builder.orderBy(azienda.nome.asc())
  })

  return defer({
    aziende: await getAziende,
    userInfo: await getAzureUserInformation(),
  })
}) satisfies LoaderFunction

export const CustomizationsPageRoute = {
  path: 'customizations',
  faIcon: faPencil,
  children: [
    {
      index: true,
      element: <CustomizationsPage />,
      loader: customizationsPageRouteLoader,
      allowedRoles: [Roles.Guest],
    } as RoleRouteObject,
    CustomizationCreatorRoute,
    CustomizationEditorRoute,
  ],
  text: 'Personalizzazioni',
  handle: {
    crumb: () => ({
      label: 'Personalizzazioni',
      icon: faPencil,
    }),
  },
  allowedRoles: [Roles.Guest],
} as RoleRouteObject
